import React from 'react'
import Hero from './Hero'
import Categories from './Categories'
import OurSellers from './OurSellers'
import MonthDeals from './MonthDeals'
import Reviews from './Reviews'
import InstagramStoriesAndServices from './InstagramStories'
import OurServices from 'components/frontend/OurServices'

export default function Home() {
    return (
        <>
            <Hero />
            <Categories />
            <OurSellers />
            <MonthDeals />
            <Reviews />
            <InstagramStoriesAndServices />
            <OurServices />
        </>
    )
}
